"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionTwoV2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var fa_1 = require("react-icons/fa");
var styles_1 = require("./styles");
var products = [
    {
        icon: (0, jsx_runtime_1.jsx)(fa_1.FaIdCard, {}),
        title: 'OCR de documentos',
        description: 'Lectura y validación automática de cédulas, pasaportes y licencias.',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(fa_1.FaUserCheck, {}),
        title: 'Biometría facial',
        description: 'Prueba de vida (liveness) y comparación de rostro contra el documento.',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(fa_1.FaListUl, {}),
        title: 'Listas de sanciones',
        description: 'Screening AML/PEP contra listas de sanciones y personas expuestas.',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(fa_1.FaCloudUploadAlt, {}),
        title: 'GBC API',
        description: 'Controla toda la experiencia de verificación mediante integración API.',
    },
];
function SectionTwoV2() {
    return ((0, jsx_runtime_1.jsx)(styles_1.Container, { children: (0, jsx_runtime_1.jsxs)(styles_1.Content, { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Cumpl\u00ED con KYC & AML sin complicaciones" }), (0, jsx_runtime_1.jsx)("p", { children: "Verific\u00E1 la identidad de tus clientes con distintas soluciones para tu negocio." }), (0, jsx_runtime_1.jsxs)(styles_1.ContainerImages, { children: [(0, jsx_runtime_1.jsx)("div", { children: products.slice(0, 2).map(function (product) { return ((0, jsx_runtime_1.jsxs)(styles_1.Card, { children: [(0, jsx_runtime_1.jsx)(styles_1.IconTile, { children: product.icon }), (0, jsx_runtime_1.jsx)("h3", { children: product.title }), (0, jsx_runtime_1.jsx)("p", { children: product.description })] }, product.title)); }) }), (0, jsx_runtime_1.jsx)(styles_1.CenterIconTile, { children: (0, jsx_runtime_1.jsx)(fa_1.FaUserShield, {}) }), (0, jsx_runtime_1.jsx)("div", { children: products.slice(2, 4).map(function (product) { return ((0, jsx_runtime_1.jsxs)(styles_1.Card, { children: [(0, jsx_runtime_1.jsx)(styles_1.IconTile, { children: product.icon }), (0, jsx_runtime_1.jsx)("h3", { children: product.title }), (0, jsx_runtime_1.jsx)("p", { children: product.description })] }, product.title)); }) })] })] }) }));
}
exports.SectionTwoV2 = SectionTwoV2;
